export default{
  new: 'New',
  disposed: 'Disposed',
  disposed_sla: 'Disposed SLA',
  inspection: 'Inspection',
  export: 'Export',
  finished: 'Finished',
  search:'Search',
  canceled:'Canceled'
}